"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ridesListStyle = void 0;

var _Colors = require("./Colors");

var ridesListStyle = {
  backgroundColor: _Colors.backgroundColor,
  paddingTop: 20,
  paddingBottom: 30
};
exports.ridesListStyle = ridesListStyle;